// extracted by mini-css-extract-plugin
export default {"muted":"Klc1-___Emdash-module__muted"};